export default function ChevronRightIcon() {
  return (
    <>
      <g id='vuesax/linear/arrow-up'>
        <g id='arrow-up'>
          <path
            id='Vector'
            d='M9.89208 19.9201L16.4217 13.4001C17.1928 12.6301 17.1928 11.3701 16.4217 10.6001L9.89208 4.08008'
            strokeWidth='2.5'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </>
  );
}
